import Api from "../../../../util/Api";

export default function getInitState() {
    return {
        ehrLabGridIsShow: true,
        ehrLabFormIsShow: false,

        ehrGridIsShow: true,
        ehrFormIsShow: false,
        ehrCovidAntigenTestFormIsShow: false,

        ehrTableAdditionalConfig: {
            initOnRender: false
        },
        ehrActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            }
        ],
        ehrRowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'downloadEHRDocument'
            },
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Módosítás',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'showEHRForm'
            },
            {
                btn_text: '<i class="fas fa-trash-alt"></i>',
                title: 'Bejegyzés törlése',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteConfirm'
            },
        ],
        ehrFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToDocumentsGrid'
            }
        ],
        ehrTableSearchFields: [
            {
                name: "patientIdType",
                label: "Páciens azonosítás típus",
                formSize: 4,
                formType: "select",
                formVisible:true,
                selectOptions: {
                    apiCallback: Api.getIdTypeList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "patientIdValue",
                label: "Páciens azonosító",
                formSize: 4,
                formVisible:true,
                formType: "text"
            },
            {
                name: "fromDate",
                label: "Időszak kezdete",
                formSize: 4,
                formVisible:true,
                formType: 'date',
            },
            {
                name: "toDate",
                label: "Időszak vége",
                formSize: 4,
                formVisible:true,
                formType: 'date',
            },
            {
                name: "documentType",
                label: "Dokumentum típus",
                formSize: 4,
                formVisible:true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getDokumentumTipusList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "breakGlass",
                label: "Sürgősségi adatlekérés",
                description: "Sürgős lekérdezés esetén indoklás szükséges!",
                formSize: 4,
                formVisible:true,
                formType: 'checkbox'
            },
            {
                label: "Sürgősségi adatlekérés oka",
                name: "breakGlassOk",
                formSize: 4,
                formVisible:true,
                formType: 'text'
            }
        ],
        ehrTableHeaderFields: [
            {
                name: "eesztid",
                label: "EESZT ID",
                visibility: false
            },
            {
                name: "documentID",
                label: "Dokumentum ID",
                visibility: false
            },
            {
                name: "documentType",
                label: "Dokumentum típus ID",
                visibility: false
            },
            {
                name: "documentTypeText",
                label: "Dokumentum típus",
                filter: {
                    type: "simple",
                },
                visibility: true
            },
            {
                name: "doctorName",
                label: "Orvos",
                filter: {
                    type: "simple",
                },
                visibility: true
            },
            {
                name: "timeStamp",
                label: "Időpont",
                visibility: true
            },
            {
                name: "ekatid",
                label: "eSeménykatalógus ID",
                visibility: false
            },
            {
                name: "mimeType",
                label: "Formátum",
                visibility: false
            },
            {
                name: "version",
                label: "Verzió",
                visibility: false
            },
            {
                name: "caseType",
                label: "Ellátás típus ID",
                visibility: false
            },
            {
                name: "caseTypeText",
                label: "Ellátás típus",
                filter: {
                    type: "simple",
                },
                visibility: true
            },
            {
                name: "hospitalCode",
                label: "Intézmény kód",
                visibility: false
            },
            {
                name: "hospitalDescr",
                label: "Intézmény",
                visibility: false
            },
            {
                name: "caseId",
                label: "Ellátás azonosító",
                visibility: false
            },
            {
                name: "admTs",
                label: "Felvétel dátuma",
                visibility: false
            },
            {
                name: "dischTS",
                label: "Elbocsátás dátuma",
                visibility: false
            },
            {
                name: "deptCode",
                label: "Ellátó osztály kódja",
                visibility: false
            },
            {
                name: "deptDescr",
                label: "Ellátó osztály megnevezése",
                visibility: true
            },
            {
                name: "diagnose",
                label: "BNO kód",
                visibility: true
            },
            {
                name: "diagnoseText",
                label: "Diagnózis",
                visibility: true
            },
            {
                name: "who",
                label: "who",
                visibility: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],

        ehrFormConfig: [
            {
                name: "documentId",
                label: "Dokumentum azonosító",
                formVisible: true,
                formSize: 3,
                formReadOnly: true,
            },
            {
                name: "ekatid",
                label: "eSeménykatalógus ID",
                formVisible: true,
                formSize: 3,
                formReadOnly: true,
            },
            {
                name: "documentType",
                label: "Dokumentum típus",
                formVisible: true,
                formRequired: true,
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getDokumentumTipusList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "caseType",
                label: "Ellátás típus",
                formVisible: true,
                formRequired: true,
                formReadOnly: true,
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getEllatasList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "admTs",
                label: "Felvétel dátuma",
                formVisible: true,
                formRequired: true,
                formReadOnly: true,
                formSize: 3,
                formType: "dateTime"
            },
            {
                name: "dischTs",
                label: "Távozás dátuma",
                formVisible: true,
                formRequired: true,
                formReadOnly: true,
                formSize: 3,
                formType: "dateTime"
            },
            {
                name: "diagnose",
                label: "Diagnózis",
                formVisible: true,
                formRequired: true,
                formSize: 3,
                formType: "selectBNOSingle",
                selectOptions: {
                    formatText: function (val) {
                        return val.leiras;
                    }
                }
            }
        ],
        ehrCovidRATFormConfig: [
            {
                name: "documentId",
                label: "Dokumentum azonosító",
                formVisible: true,
                formSize: 3,
                formReadOnly: true,
            },
            {
                name: "ekatid",
                label: "eSeménykatalógus ID",
                formVisible: true,
                formSize: 3,
                formReadOnly: true,
            },
            {
                name: "documentType",
                label: "Dokumentum típus",
                formVisible: true,
                formRequired: true,
                formReadOnly: true,
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getDokumentumTipusList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "caseType",
                label: "Ellátás típus",
                formVisible: true,
                formRequired: true,
                formReadOnly: true,
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getEllatasList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "admTs",
                label: "Felvétel dátuma",
                formVisible: true,
                formRequired: true,
                formReadOnly: true,
                formSize: 3,
                formType: "dateTime"
            },
            {
                name: "dischTs",
                label: "Távozás dátuma",
                formVisible: true,
                formRequired: true,
                formReadOnly: true,
                formSize: 3,
                formType: "dateTime"
            },
            {
                name: "eredmeny",
                label: "Diagnózis",
                formVisible: true,
                formRequired: true,
                formSize: 3,
                formType: "select",
                selectOptions: {
                    externalOptionList: [{id: 'U0710', text: 'Pozitív'}, {id: 'U9990', text: 'Negatív'}, {id: '-1', text: 'Nem értékelhető'}],
                    formatText: function(val){
                        return val.text;
                    },
                    formatOption: function(val){
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "tesztTipus",
                label: "Teszt típusa",
                formVisible: true,
                formRequired: true,
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getCovidRapidTestList,
                    formatText: function (val) {
                        return val.commercialName;
                    },
                    formatOption: function (val) {
                        return val.commercialName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'commercialName',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            /*{
                name: "ogyeiAzonosito",
                label: "OGYEI azonosító",
                formVisible: true,
                formSize: 3,
                formType: "text"
            },*/
            {
                name: "termekGyartasiSorozatAzonosito",
                label: "Termék gyártási sorozat azonosítója",
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "termekEgyediGyartasiAzonosito",
                label: "Termék egyedi gyártási azonosítója",
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "termekLejaratiDatum",
                label: "Termék lejárati dátuma",
                formVisible: true,
                formSize: 3,
                formType: "date"
            },
            {
                name: "mintaTipusa",
                label: "Minta típusa",
                formVisible: true,
                formRequired: false,
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getMintavetelTipusList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "mintavetelIdopontja",
                label: "Mintavétel időpontja",
                formVisible: true,
                formRequired: true,
                formSize: 3,
                formType: "dateTime"
            },
            {
                name: "eredmenyIdopontja",
                label: "Eredmény időpontja",
                formVisible: true,
                formRequired: false,
                formSize: 3,
                formType: "dateTime"
            }
        ],

        ehrSpecialistAdviceDrugFormConfig: [
            {
                name: "taj",
                label: "TAJ",
                formVisible: false
            },
            {
                name: "caseId",
                label: "Ellátás azonosító",
                formVisible: true,
                formSize: 3,
                formReadOnly: true,
            },
            {
                name: "ekatid",
                label: "eSeménykatalógus ID",
                formVisible: true,
                formSize: 3,
                formReadOnly: true,
            },
            {
                name: "documentType",
                label: "Dokumentum típus",
                formVisible: true,
                formRequired: true,
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getDokumentumTipusList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "caseType",
                label: "Ellátás típus",
                formVisible: true,
                formRequired: true,
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getEllatasList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "diagnose",
                label: "Diagnózis",
                formVisible: true,
                formRequired: true,
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getBnoKodList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 2,
                    searchOnServer: true,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },

            {
                name: "drugId",
                label: "Gyógyszer",
                formVisible: true,
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getDrugByFilter,
                    formatText: function(val){
                        return val.text;
                    },
                    formatOption: function(val){
                        return val.text;
                    },
                    minimumInputLength: 3,
                    searchOnServer: true,
                    filteredAttr: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "adagolas",
                label: "Adagolás",
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "tamogatasMerteke",
                label: "Támogatás mértéke",
                formVisible: true,
                formSize: 3,
                formType: "select",
                selectOptions: {
                    externalOptionList: [
                        {id: 'EÜ50', text: 'EÜ50'},
                        {id: 'EÜ70', text: 'EÜ70'},
                        {id: 'EÜ90', text: 'EÜ90'},
                        {id: 'EÜ100', text: 'EÜ100'}
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "tamogatasKategoria",
                label: "Támogatás kategória",
                formVisible: true,
                formSize: 3,
                formType: "select",
                selectOptions: {
                    externalOptionList: [
                        {id: 'emelt', text: 'emelt'},
                        {id: 'kiemelt', text: 'kiemelt'}
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "admTs",
                label: "Felvétel dátuma",
                formVisible: true,
                formRequired: true,
                formSize: 3,
                formType: "dateTime"
            },
            {
                name: "dischTs",
                label: "Távozás dátuma",
                formVisible: true,
                formRequired: true,
                formSize: 3,
                formType: "dateTime"
            }
        ],

        specialistAdviceDrugFormConfig: [
            {
                name: "taj",
                label: "TAJ",
                formVisible: false
            },
            {
                name: "caseId",
                label: "Ellátás azonosító",
                formVisible: true,
                formSize: 4,
                formReadOnly: true,
            },
            {
                name: "ekatid",
                label: "eSeménykatalógus ID",
                formVisible: true,
                formSize: 4,
                formReadOnly: true,
            },
            {
                name: "documentType",
                label: "Dokumentum típus",
                formVisible: true,
                formRequired: true,
                formSize: 4,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getDokumentumTipusList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "diagnose",
                label: "Diagnózis",
                formVisible: true,
                formRequired: true,
                formSize: 6,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getBnoKodList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 2,
                    searchOnServer: true,
                    filteredAttr: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },

            {
                name: "drugId",
                label: "Gyógyszer",
                formVisible: true,
                formRequired: true,
                formSize: 6,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getDrugByFilter,
                    formatText: function(val){
                        return val.text;
                    },
                    formatOption: function(val){
                        return val.text;
                    },
                    minimumInputLength: 3,
                    searchOnServer: true,
                    filteredAttr: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "caseType",
                label: "Ellátás típus",
                formVisible: true,
                formRequired: true,
                formSize: 4,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getEllatasList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "adagolas",
                label: "Adagolás",
                formVisible: true,
                formSize: 4,
                formType: "text"
            },
            {
                name: "tamogatasMerteke",
                label: "Támogatás mértéke",
                formVisible: true,
                formSize: 4,
                formType: "select",
                selectOptions: {
                    externalOptionList: [
                        {id: 'EÜ50', text: 'EÜ50'},
                        {id: 'EÜ70', text: 'EÜ70'},
                        {id: 'EÜ90', text: 'EÜ90'},
                        {id: 'EÜ100', text: 'EÜ100'}
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "tamogatasKategoria",
                label: "Támogatás kategória",
                formVisible: true,
                formSize: 4,
                formType: "select",
                selectOptions: {
                    externalOptionList: [
                        {id: 'emelt', text: 'emelt'},
                        {id: 'kiemelt', text: 'kiemelt'}
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "admTs",
                label: "Felvétel dátuma",
                formVisible: true,
                formRequired: true,
                formSize: 4,
                formType: "dateTime"
            },
            {
                name: "dischTs",
                label: "Távozás dátuma",
                formVisible: true,
                formRequired: true,
                formSize: 4,
                formType: "dateTime"
            }
        ],

        labDocumentsRowActions: [
            {
                btn_text: '<i class="fas fa-cloud-upload-alt"></i>',
                title: 'Feltöltés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'uploadLab'
            },
        ],
        labDocumentsTableHeaderFields: [
            {
                label: "Azonosító",
                name: "id",
                visibility: false
            },
            {
                label: "Név",
                name: "patient.name",
                filter: {
                    type: "simple",
                },
                sort: true
            },
            {
                label: "Születési hely",
                name: "patient.placeOfBirth",
            },
            {
                label: "Születési idő",
                name: "patient.dateOfBirth",
                slot_name: "date_format"
            },
            {
                label: "Orvos",
                name: "doctor.fullName",
                filter: {
                    type: "simple",
                },
                sort: true
            },
            {
                label: "Labor típus",
                name: "labType.text",
                filter: {
                    type: "simple",
                },
                sort: true
            },
            {
                label: "Küldés dátuma",
                name: "startDate",
                slot_name: "startDate_format",
                sort: true
            },
            {
                label: "Határidő",
                name: "resultDate",
                slot_name: "resultDate_format",
                sort: true
            },
            {
                label: "Állapot",
                filter: {
                    type: "simple",
                },
                name: "status.text",
                sort: true
            },
            {
                label: "Opciók",
                name: "buttons",
                sort: false
            }
        ],

        evidenceDocumentsRowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                event_payload: 'showEvidence'
            },
            {
                btn_text: '<i class="fas fa-cloud-upload-alt"></i>',
                title: 'Feltöltés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'uploadEvidence'
            }
        ],
        evidenceDocumentsTableConfig: {
            per_page: 10
        },
        evidenceDocumentsTableHeaderFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false
            },
            {
                name: "finalReport",
                label: "Tartalom",
                visibility: false
            },
            {
                name: "clinicId",
                label: "Szakrendelés ID",
                visibility: false
            },
            {
                name: "patientId",
                label: "Páciens ID",
                visibility: false
            },
            {
                name: "treatmentId",
                label: "Kezelés ID",
                visibility: false
            },
            {
                name: "siteId",
                label: "Telephely ID",
                visibility: false
            },
            {
                name: "treatment",
                label: "Kezelés",
                visibility: false
            },
            {
                name: "clinic.text",
                label: "Szakrendelés",
                filter: {
                    type: "simple",
                },
                sort: true
            },
            {
                name: "treatment.treatmentType.title",
                label: "Kezelés",
                filter: {
                    type: "simple",
                },
                sort: true
            },
            {
                name: "createdOn",
                label: "Készítés dátuma",
                slot_name: "created_on_format",
                visibility: true
            },
            {
                name: "createdBy",
                label: "Készítette",
                visibility: true
            },
            {
                name: "isClosed",
                label: "Lezárt?",
                filter: {
                    type: "simple",
                },
                slot_name: "isClosed_format",
                sort: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
            }
        ],
        specRecSelectRowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'downloadEHRDocument'
            },
            {
                btn_text: '<i class="fas fa-arrow-right"></i>',
                title: 'Kiválasztás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'selectRow'
            }
        ],
    }
}
